export default __webpack_public_path__ + "static/media/mercado_pago.85ac3666.svg";